<template>
  <div class="zjxheader">
    <div class="zjxheader_center">
      <img :src="infoDetail.logo" class="zjxheader_center__img" alt="" />
      <img
        class="phoneLanmu"
        @click="openPhoneNav"
        src="../assets/img/webIndex/mulu.png"
        alt=""
      />
      <div class="headOrHide">
        <div class="zjxheader_center__left">
          <img
            src="../assets/img/webIndex/phone.png"
            style="width: 21px; height: 20px; margin-top: -2px"
            alt=""
          />
          <p class="zjxheader_center__left_p">
            {{ infoDetail.cellphone }}
          </p>
        </div>
        <div>
          <newNavBar></newNavBar>
        </div>
      </div>
      <div class="rightUser" v-if="userInfo.realName">
        <p>{{ userInfo.realName ? userInfo.realName : "会员" }}</p>
        <el-popover placement="bottom" width="70" trigger="hover">
          <div class="rightUser_center">
            <el-badge :value="totalNum" :hidden="!(totalNum > 0)" class="item">
              <p @click="$router.push('/noticeCenter')">消息中心</p>
            </el-badge>
            <p @click="$router.push('/changepassword')">修改密码</p>
            <p @click="loginOut">退出登录</p>
          </div>
          <img
            slot="reference"
            :src="userInfo ? userInfo.photo : userHeadNormal"
            @click="reback"
            alt=""
          />
        </el-popover>
      </div>
      <!-- 非会员 -->
      <div class="rightUser" v-if="userPhone">
        <el-popover placement="bottom" width="70" trigger="hover">
          <div class="rightUser_center">
            <el-badge :value="totalNum" :hidden="!(totalNum > 0)" class="item">
              <p @click="$router.push('/noticeCenter')">消息中心</p>
            </el-badge>
            <!-- <p @click="$router.push('/register')">注册会员</p> -->
            <p @click="loginOut">退出登录</p>
          </div>
          <p slot="reference" style="cursor: pointer">
            用户&nbsp;&nbsp;{{ userPhone }}
          </p>
        </el-popover>
      </div>
    </div>
    <!-- 栏目 -->
    <el-drawer
      title="导航栏"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="50%"
    >
      <div v-for="(items, index) in navList" :key="index">
        <div v-if="items.children.length && index !== 0">
          <p class="newNavBar" @click="navtoPage(items)">{{ items.label }}</p>
          <span
            class="newNavBar_span"
            v-for="(item, key) in items.children"
            @click.stop="navToList(items, item, index)"
            :key="key"
          >
            {{ item.label }}
          </span>
        </div>
        <div v-else>
          <p class="newNavBar" @click="navtoPage(items)">{{ items.label }}</p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import newNavBar from "./newNavBar.vue";
import { getBasicInfo, getNavList } from "../api/moudles/user.js";
export default {
  components: {
    newNavBar,
  },
  data() {
    return {
      isNoVipLogin: false,
      navList: [],
      drawer: false,
      direction: "rtl",
      infoDetail: {},
      userHeadNormal: require("../assets/img/userIndex/head.png"),
    };
  },
  created() {
    this.getNavList();
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    userInfo: (state) => state.user.userInfo,
    userPhone: (state) => state.user.noVipPhone,
    totalNum: (state) => state.user.noticeCount,
  }),
  mounted() {
    if (!this.userPhone) {
      if (this.$store.state.user.token) {
        // 会员
        if (!this.userInfo.realName) {
          this.$store.dispatch("user/GET_USERINFO");
        }
      }
    }
  },
  methods: {
    navToList(father, child, index) {
      localStorage.setItem("navIndex", index);
      // 资讯或者文件下载
      if (child.model == "1" || child.model == "8") {
        localStorage.setItem("columnCode", child.key);
        localStorage.setItem("columnName", child.label);
        localStorage.setItem("columnStatus", child.model);
        localStorage.setItem("columnName0", father.label);
        localStorage.setItem("columnCode0", father.key);
        this.$router.push({
          name: "empty",
        });
      }
      // 实际页面
      if (child.model == "4") {
        if (this.$phoneSize()) {
          this.$router.push(`/phoneIndex/${child.link}`);
        } else {
          this.$router.push(`/${child.link}`);
        }
      }
      // 外链
      if (child.model == "0") {
        if (child.link) {
          window.open(child.link, "_self");
        }
      }
      this.drawer = false;
    },
    // 跳转导航栏
    navtoPage(items) {
      this.drawer = false;
      if (items.model == "18") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);
        // 首页
        this.$router.push("/phone");
      }
      if (items.model == "1" || items.model == "8") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);
        this.$router.push({
          name: "phoneEmpty",
        });
      }
      if (items.model == "0") {
        this.navList.forEach((item) => {
          if (item.label == "行业动态") {
            localStorage.setItem("columnCode", item.key);
            localStorage.setItem("columnName", item.label);
            localStorage.setItem("columnStatus", item.model);
          }
        });

        if (items.link) {
          const newLink = items.link.split("/");
          newLink.splice(3, 0, "phoneIndex");
          const nowLink = newLink.join("/");
          window.open(nowLink, "_self");
        }
      }
      // 视频-从这开始
      if (items.model == "12") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);
        this.$router.push({
          path: "/phoneIndex/courseLearn",
        });
      }
      // 业务活动mode7-模型是单页
      if (items.model == "7") {
        localStorage.setItem("columnCode", items.key);
        localStorage.setItem("columnName", items.label);
        localStorage.setItem("columnStatus", items.model);
        this.$router.push({
          name: "phoneActivitiesList",
        });
      }
    },
    // 关闭侧边栏
    handleClose(done) {
      done();
    },
    openPhoneNav() {
      this.drawer = true;
    },
    // 退出登录
    loginOut() {
      // 个人会员
      this.$store.commit("user/RESET_INFO");
      // 非个人会员
      setTimeout(() => {
        this.$message({
          message: "退出成功，请重新登录!",
          type: "success",
        });
      }, 500);
      if (this.$route.meta.requireAuth) {
        // 需要登录
        this.$router.replace("/login");
      }
    },
    // 回到系统
    reback() {
      if (this.$route.path != "/userinfo") {
        this.$router.replace("/home");
      }
    },
    // 导航栏
    async getNavList() {
      this.topNav = false;
      await getNavList({
        data: {
          position: 1,
        },
        success: (res) => {
          // console.log('导航栏', res)
          this.navList = res.data;
          const indexCodeList = res.data[0].children;
          indexCodeList.forEach((item) => {
            if (item.label == "基本信息") {
              this.getBasicInfo(item.key);
            }
          });
        },
      });
    },
    // 获取基本信息
    async getBasicInfo(column_code) {
      await getBasicInfo({
        data: {
          column_code,
        },
        success: (res) => {
          this.infoDetail = res.data;
        },
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .zjxheader {
    height: 80px;
    width: 100%;
    background-color: #c01219;

    z-index: 990;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
  }

  .zjxheader_center {
    position: relative;
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .zjxheader_center__img {
    width: 85%;
  }

  .headOrHide {
    display: none;
  }

  .rightUser {
    display: none !important;
  }

  .phoneLanmu {
    width: 35px;
    height: 35px;
  }

  .newNavBar {
    height: 45px;
    width: 100%;
    padding-left: 20%;
    line-height: 45px;
    box-sizing: border-box;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  .newNavBar_span {
    display: block;
    height: 35px;
    width: 100%;
    padding-left: 25%;
    line-height: 35px;
  }

  :deep(.el-drawer) {
    background-color: #c22c25;
    color: #fff;
  }

  :deep(.el-drawer__header) {
    color: #fff;
  }
}

@media screen and (min-width: 750px) {
  .phoneLanmu {
    display: none;
  }

  .zjxheader {
    height: 100px;
    width: 100%;
    background-color: #c01219;

    z-index: 990;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
  }

  .zjxheader_center {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    height: 100px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .zjxheader_center__img {
    width: 410px;
    height: 55px;
  }
}

.rightUser_center {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.rightUser_center p {
  height: 30px;
  line-height: 30px;
}

.rightUser_center p:hover {
  color: #c01219;
  cursor: pointer;
}

.rightUser {
  right: -300px;
  position: absolute;
  width: 300px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rightUser p {
  color: #fff;
  margin-right: 10px;
}

.rightUser img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  object-fit: scale-down;
}

.zjxheader_center__left {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.zjxheader_center__left_p {
  margin-left: 6px;
  height: 50px;
  line-height: 50px;
  text-align: right;
  color: #fff;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
}
</style>
